import { Field, RadioGroup, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { FieldSet, ListFieldSection } from 'Components/Layout';
import { IWithWorksheetInjectedProps, WorksheetEquipmentDropdown } from 'Components/Worksheets//Core';
import { hasNonEmptyValue } from 'Lib/Any';
import React from 'react';
import { useSelector } from 'react-redux';

let LiquidLimitEquipmentDetailsSection: React.FC<IWithWorksheetInjectedProps> = ({ createWorksheetSelector }) => {
  const groovingToolId = useSelector(createWorksheetSelector!('GroovingTool.Id'));
  const groovingToolType = useSelector(createWorksheetSelector!('GroovingToolType'));
  const groovingToolShape = useSelector(createWorksheetSelector!('GroovingToolShape'));
  const groovingToolImportMismatch = useSelector(createWorksheetSelector!('GroovingToolImportMismatch'));

  return (
    <ListFieldSection heading="Equipment Details">
      <Field
        input={<RadioGroup />}
        label="Liquid Limit Apparatus"
        name="ApparatusType"
        options={[
          { label: 'Manual', value: 'Manual' },
          { label: 'Mechanical', value: 'Mechanical' },
        ]}
      />
      <FieldSet>
        <Field
          input={<WorksheetEquipmentDropdown />}
          label="Grooving Tool"
          equipmentType="grooving-tool"
          name="GroovingTool"
          importedAdditionalData={{
            GroovingToolType: groovingToolType,
            GroovingToolShape: groovingToolShape,
            Mismatch: groovingToolImportMismatch,
          }}
          importModel={{ Id: groovingToolId }}
        />
        {hasNonEmptyValue(groovingToolId) ? (
          <>
            <Field input={<TextOutput />} label="Grooving Tool Material" name="GroovingToolType" />
            <Field input={<TextOutput />} label="Grooving Tool Shape" name="GroovingToolShape" />
          </>
        ) : (
          <>
            <Field
              input={<RadioGroup />}
              label="Grooving Tool Material"
              name="GroovingToolType"
              options={[
                { label: 'Metal', value: 'Metal' },
                { label: 'Plastic', value: 'Plastic' },
              ]}
            />
            <Field
              input={<RadioGroup />}
              label="Grooving Tool Shape"
              name="GroovingToolShape"
              options={[
                { label: 'Flat', value: 'Flat' },
                { label: 'Curved', value: 'Curved' },
              ]}
            />
          </>
        )}
      </FieldSet>
    </ListFieldSection>
  );
};

LiquidLimitEquipmentDetailsSection = withInjectedProps(LiquidLimitEquipmentDetailsSection);

export { LiquidLimitEquipmentDetailsSection };
export default LiquidLimitEquipmentDetailsSection;
